import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { updateTestParamsMap as updateTestParamsMapUiElement } from '../uiElements/actions';
import { updateTestParamsMap as updateTestParamsMapNativeElement } from '../nativeElements/actions';
import { reloadSelectedWorkflow } from '../selectedWorkflow/actions';
import state from './state';
import { SET_PREVENT_FLAG_FOR_ELEMENT } from './mutations';

const buildElementActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const updateTestParamsMap = buildElementActionObject('updateTestParamsMap');
export const handleElementUpdated = buildElementActionObject('handleElementUpdated');
export const setPreventFlagForElement = buildElementActionObject('setPreventFlagForElement');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [updateTestParamsMap.action]({ dispatch }, payload) {
		const { elementId, paramsMap, paramsMapLabels, isNative } = payload;
		return dispatch(
			isNative ? updateTestParamsMapNativeElement.fullPath : updateTestParamsMapUiElement.fullPath,
			{ elementId, paramsMap, paramsMapLabels },
			{ root: true }
		);
	},
	[handleElementUpdated.action]({ dispatch }, payload) {
		const { pk: elementId } = payload;
		// todo separate this logic, we need to retrieve the wanted element (nativeElement or uiElement), for now we do it by reloading the flow object
		if (state.elementsPreventsFlags[elementId]) {
			dispatch(setPreventFlagForElement.action, { id: elementId, value: false });
			return;
		}
		dispatch(reloadSelectedWorkflow.fullPath, { forceGetNodes: false }, { root: true });
	},
	[setPreventFlagForElement.action]({ commit }, payload) {
		// const { id, value } = payload;
		commit(SET_PREVENT_FLAG_FOR_ELEMENT, payload);
	},
};

export default actions;
